import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { AuthService } from './auth.service';
import { environment as env } from '../../environments/environment';
import { ToastService } from './toast.service';
const localLog = console.log;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient,
    private loadingService: LoadingService,
    private authService: AuthService,
    private toast: ToastService) {

  }

  private _get_headers() {
    return {      withCredentials: true
    };
  }

  async getUserScanners(): Promise<any> {
    let _id = this.loadingService.add('Loading user scanners');
    try {
      let res: any = await this.http.get(
        `${env.apiUrl}/rest/api/scanners`,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error getUserScanners() =>', e);
      this.toast.error('Failed to get user scanners', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }
}
